<template>
	<div class="modify-img">
		<el-dialog
			title="修改图片"
			top="4vh"
			width="1200px"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			:visible.sync="dialogVisible"
			@close="closeDialog"
		>
			<el-row type="flex" justify="end">
				<el-button
					type="success"
					@click="handleUpload"
					:loading="loadingUpload"
					>上 传</el-button
				>
			</el-row>
			<el-tabs v-model="tabName" @tab-click="handleTabClick">
				<template v-for="item in listTabs">
					<el-tab-pane
						:label="item.cusSku"
						:name="item.cusSku"
						:key="item.id"
					>
						<el-form class="custom-form" label-position="top">
							<el-form-item label="父体图片">
								<draggable
									class="draggable-box"
									tag="ul"
									:list="item.cusImages"
									handle=".img-box2"
								>
									<li
										class="img-box2"
										v-for="(key, index) in item.cusImages"
										:key="key"
									>
										<div class="mask">
											<i
												class="custom-icon el-icon-delete"
												@click="
													handleRemoveSelect(
														key,
														index
													)
												"
											></i>
										</div>
										<el-image
											class="mb"
											style="width: 100px;height: 100px;"
											:src="key"
										></el-image>
									</li>
									<el-upload
										:multiple="true"
										:action="uploadAction"
										:show-file-list="false"
										:headers="uploadHeaders"
										:on-success="handleAvatarSuccess"
									>
										<i class="el-icon-plus"></i>
									</el-upload>
								</draggable>
							</el-form-item>
						</el-form>
						<!-- :lazy="true" :load="tableLoad" -->
						<el-table
							:key="tabName"
							ref="multipleTable"
							:data="[item]"
							border
							:lazy="true"
							default-expand-all
							row-key="id"
							:tree-props="{
								children: 'children',
								hasChildren: 'variantCount',
							}"
						>
							<el-table-column
								prop="cusSku"
								label="变体SKU"
								width="400"
								align="center"
							></el-table-column>
							<el-table-column label="图片" align="center">
								<template slot-scope="scope">
									<el-row
										class="img-box"
										type="flex"
										align="middle"
									>
										<template
											v-for="key in scope.row.cusImages.slice(
												0,
												9
											)"
										>
											<el-image
												style="width: 50px;height: 50px;"
												:src="key"
												:key="key"
											></el-image>
										</template>
										<div v-if="!scope.row.isShow">
											<el-button
												icon="el-icon-edit-outline"
												@click="
													childSelectImg(scope.row)
												"
											></el-button>
											<el-dropdown
												style="margin-left: 10px;"
												placement="bottom"
												@command="
													handleDropdownCommand(
														$event,
														scope.row
													)
												"
											>
												<el-button>
													同步
													<i
														class="el-icon-arrow-down"
													></i>
												</el-button>
												<el-dropdown-menu
													slot="dropdown"
												>
													<el-dropdown-item
														command="all"
														>所有变体</el-dropdown-item
													>
													<el-dropdown-item
														command="color"
														>相同颜色</el-dropdown-item
													>
													<el-dropdown-item
														command="size"
														>相同尺寸</el-dropdown-item
													>
												</el-dropdown-menu>
											</el-dropdown>
										</div>
									</el-row>
								</template>
							</el-table-column>
						</el-table>
					</el-tab-pane>
				</template>
			</el-tabs>
			<div slot="footer">
				<el-button
					type="primary"
					@click="submitUpdate"
					:loading="loadingUpdate"
					>更 新</el-button
				>
			</div>
			<!--   S：编辑图片   -->
			<el-dialog
				title="编辑图片"
				width="1000px"
				top="4vh"
				:close-on-click-modal="false"
				:close-on-press-escape="false"
				:visible.sync="dialogVisibleInner"
				append-to-body
				@close="dialogCheckedImgs = []"
			>
				<el-alert
					title="变体图片最多选择9张"
					type="error"
					:closable="false"
				></el-alert>
				<el-row type="flex" class="inner-img-box">
					<div
						class="inner-img"
						v-for="key in dialogInnerImgs"
						:key="key"
					>
						<div class="img-mask" v-if="dialogInnerIsChecked(key)">
							<i class="el-icon-upload-success el-true-check">
								{{
									dialogCheckedImgs.findIndex(
										(img) => img === key
									) + 1
								}}
							</i>
						</div>
						<el-image
							:class="{ active: dialogInnerIsChecked(key) }"
							style="width: 100px;height: 100px;"
							:src="key"
							@click="addDialogCheckedImgs(key)"
						></el-image>
					</div>
				</el-row>
				<el-divider></el-divider>
				<div slot="footer">
					<el-button type="primary" @click="confirmCheckImg"
						>确 定</el-button
					>
				</div>
			</el-dialog>
			<!--   E：编辑图片   -->
		</el-dialog>
	</div>
</template>

<script>
import draggable from 'vuedraggable'
import { ajaxPost, Baseurl } from '@/api/api/api'

const variantMaps = new Map()

export default {
	name: 'ModifyImg',
	components: {
		draggable,
	},
	data() {
		return {
			uploadAction: Baseurl + 'imageController/uploadImage',
			uploadHeaders: { token: localStorage.getItem('token') },
			tabName: '',
			listTabs: [],
			Tab_Data: [],
			dialogInnerImgs: [],
			shopItem: null,
			dialogCheckedImgs: [],
			dialogVisible: false,
			loadingUpdate: false,
			dialogVisibleInner: false,
			loadingUpload: false,
			childrenIndex: -1,
			tabIndex: 0,
		}
	},
	computed: {},
	watch: {},
	methods: {
		openDialog(list, shopItem) {
			this.shopItem = shopItem
			this.listTabs = JSON.parse(JSON.stringify(list))
			//   this.Tab_Data=this.listTabs[0];
			this.tabName = list[0].cusSku
			//   this.handleTabClick();
			this.refreshTableLoad()
			this.getTableItemVariantT(this.listTabs[0])
			this.dialogVisible = true
			this.isUpdate = false
		},
		getTableItemVariantT(tree) {
			const API = Baseurl + 'productController/selectVariantByProductId'
			const paramsData = { id: tree.id }
			ajaxPost(API, paramsData).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					data.forEach((item) => {
						item.cusSku = item.childSku
						item.cusImgUrl = item.variantEanImageUrl
						const countryVal =
							item.productPriceObject[tree.areaName]
						item.cusPrice = `${countryVal.value} (${countryVal.currency})`
						item.cusSalePrice = `${item.sale || 0} (${
							countryVal.currency
						})`
						item.cusProductPrice = `${countryVal.value}`
						item.cusTitle = `${tree.title || ''} ${item.childSku ||
							''}`
						item.isShow = false
						item.saleTime = [
							item.saleBeginTime || '',
							item.saleEndTime || '',
						]
						item.cusStock = item.stock
						item.cusImages = item.imagesList
					})
					this.listTabs[this.tabIndex].children = data
					// resolve(data)
				}
			})
		},
		closeDialog() {
			if (this.isUpdate) {
				this.$emit('close')
			}
		},
		handleTabClick() {
			this.tabIndex = this.listTabs.findIndex(
				(item) => item.cusSku === this.tabName
			)
			//   this.Tab_Data=JSON.parse(JSON.stringify(this.listTabs[this.tabIndex]));
			//    console.log(JSON.parse(JSON.stringify(this.Tab_Data)));
			this.$nextTick(() => {
				const API =
					Baseurl + 'productController/productOnlineSerchBySku'
				const params = {
					sku: this.listTabs[this.tabIndex].sku,
					areaName: this.listTabs[this.tabIndex].areaName,
					staffId: this.listTabs[this.tabIndex].staffId,
				}
				ajaxPost(API, params).then((res) => {
					if (res.data.code == 200) {
						this.listTabs[this.tabIndex].cusImages =
							res.data.data.productImgUrls
						const tabItem = this.listTabs[this.tabIndex]
						this.getTableItemVariantT(tabItem)
					}
				})
			})
		},
		handleAvatarSuccess(response) {
			const { code, data } = response
			if (code !== 200) return
			this.listTabs[this.tabIndex].cusImages.push(data)
		},
		handleRemoveSelect(img, index) {
			const tempObj = this.listTabs[this.tabIndex]
			tempObj.cusImages.splice(index, 1)
			tempObj.children.forEach((item) => {
				const itemIndex = item.cusImages.findIndex((key) => key === img)
				if (itemIndex < 0) return
				item.cusImages.splice(itemIndex, 1)
			})
		},
		childSelectImg(row) {
			const tempObj = this.listTabs[this.tabIndex]
			this.dialogInnerImgs = [...tempObj.cusImages]
			this.childrenIndex = tempObj.children.findIndex(
				(item) => item.id === row.id
			)
			this.dialogCheckedImgs = [
				...tempObj.children[this.childrenIndex].cusImages,
			]
			this.dialogVisibleInner = true
		},
		addDialogCheckedImgs(item) {
			const itemIndex = this.dialogCheckedImgs.indexOf(item)
			if (itemIndex > -1) {
				this.dialogCheckedImgs.splice(itemIndex, 1)
			} else {
				if (this.dialogCheckedImgs.length >= 9) return
				this.dialogCheckedImgs.push(item)
			}
		},
		dialogInnerIsChecked(item) {
			const result = this.dialogCheckedImgs.includes(item)
			return result
		},
		confirmCheckImg() {
			if (this.childrenIndex > -1) {
				this.listTabs[this.tabIndex].children[
					this.childrenIndex
				].cusImages = [...this.dialogCheckedImgs]
			}
			this.dialogVisibleInner = false
		},
		async tableLoad(tree, treeNode, resolve) {
			variantMaps.set(tree.id, { tree, treeNode, resolve })

			const variantData = await this.getTableItemVariant(tree)
			resolve(variantData)
		},
		refreshTableLoad() {
			try {
				this.listTabs.forEach((item) => {
					const itemObj = variantMaps.get(item.id)
					if (!itemObj) return
					const { tree, treeNode, resolve } = itemObj
					if (tree) {
						this.tableLoad(tree, treeNode, resolve)
					}
				})
			} catch (e) {
				console.log(e)
			}
		},

		getTableItemVariant(tree) {
			const API = Baseurl + 'productController/selectVariantByProductId'
			const paramsData = { id: tree.id }
			return new Promise((resolve, reject) => {
				ajaxPost(API, paramsData).then((res) => {
					const { code, data } = res.data
					if (code === 200) {
						data.forEach((item) => {
							item.cusSku = item.childSku
							item.cusImgUrl = item.variantEanImageUrl
							const countryVal =
								item.productPriceObject[tree.areaName]
							item.cusPrice = `${countryVal.value} (${countryVal.currency})`
							item.cusSalePrice = `${item.sale || 0} (${
								countryVal.currency
							})`
							item.cusProductPrice = `${countryVal.value}`
							item.cusTitle = `${tree.title ||
								''} ${item.childSku || ''}`
							item.isShow = false
							item.saleTime = [
								item.saleBeginTime || '',
								item.saleEndTime || '',
							]
							item.cusStock = item.stock
							item.cusImages = item.imagesList
						})
						this.listTabs[this.tabIndex].children = data
						resolve(data)
					} else {
						reject('400')
					}
				})
			})
		},
		handleTableVal(obj) {
			const resultTableVal = {
				product: {
					id: obj.id,
					productImgUrl: JSON.stringify(obj.cusImages),
				},
				variantEans: obj.children.map((item) => ({
					id: item.id,
					images: JSON.stringify(item.cusImages),
				})),
			}
			return resultTableVal
		},
		submitUpdate() {
			const API =
				Baseurl + 'productController/batchUpdateProductAndVariant'
			const paramsData = this.handleTableVal(this.listTabs[this.tabIndex])
			this.loadingUpdate = true
			this.isUpdate = true
			ajaxPost(API, paramsData).then((res) => {
				const { code } = res.data
				this.loadingUpdate = false
				if (code === 200) {
					this.$message.success('操作成功')
				}
			})
		},
		handleUpload() {
			const API = Baseurl + 'amaoznFeedUpload/saleProductSubmit'
			const paramsData = {
				ids: this.listTabs.map((item) => item.id),
				marketInfo: JSON.stringify({
					sellerId: this.shopItem.sellerId,
					mwsAuthToken: this.shopItem.mwsAuthToken,
					countryMark: this.shopItem.countryMark,
					marketplaceId: this.shopItem.marketPlaceId,
				}),
				type: 3, // （基本信息1  图片3 价格4 库存5）
			}
			//   console.log(JSON.parse(JSON.stringify(paramsData)))
			// return
			this.loadingUpload = true
			ajaxPost(API, paramsData).then((res) => {
				this.loadingUpload = false
				const { code, data } = res.data
				if (code === 200) {
					this.$message.success(data)
				}
			})
		},
		handleDropdownCommand(command, item) {
			switch (command) {
				case 'all':
					this.listTabs[this.tabIndex].children.forEach(
						(key) => (key.cusImages = item.cusImages)
					)
					break
				case 'color':
					this.listTabs[this.tabIndex].children
						.filter((key) => key.color === item.color)
						.forEach((key) => (key.cusImages = item.cusImages))
					break
				case 'size':
					this.listTabs[this.tabIndex].children
						.filter((key) => key.size === item.size)
						.forEach((key) => (key.cusImages = item.cusImages))
					break
				default:
					console.log('错误的command')
					break
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.modify-img {
	::v-deep {
		.custom-form {
			margin: 10px 0;

			.el-form-item {
				margin: 0;
			}

			.el-form-item + .el-form-item {
				margin-left: 10px;
			}

			.el-upload {
				width: 100px;
				height: 100px;
				line-height: 100px;
				border-radius: 0;
				border: 1px dashed #c0ccda;

				.el-icon-plus {
					font-size: 20px;
					color: #aaa;
				}
			}
		}
	}

	.img-box {
		flex-wrap: wrap;

		.el-image {
			border: 1px solid #cccccc;
			margin-right: 10px;
		}
	}

	.draggable-box {
		display: flex;
		flex-wrap: wrap;

		.img-box2 {
			border: 1px solid #cccccc;
			margin-right: 10px;
			margin-bottom: 10px;
			position: relative;
			overflow: hidden;

			.el-image {
				display: block;
			}

			.mask {
				width: 100%;
				height: 100%;
				display: flex;
				justify-content: center;
				align-items: center;
				background: rgba(0, 0, 0, 0.5);
				position: absolute;
				top: 0;
				left: 0;
				z-index: 999;
				opacity: 0;
				transition-duration: 0.5s;

				.custom-icon {
					font-size: 20px;
					margin: 0 8px;
					color: #fff;
					cursor: pointer;
				}
			}

			&:hover .mask {
				opacity: 1;
				border-color: #409eff;
			}
		}
	}
}

.inner-img-box {
	flex-wrap: wrap;
	margin-top: 20px;

	.inner-img {
		border: 1px solid #cccccc;
		margin-right: 10px;
		margin-bottom: 10px;
		position: relative;
		overflow: hidden;

		&.active {
			border: 1px solid green;
		}

		.img-mask {
			position: absolute;
			right: -17px;
			top: -7px;
			z-index: 999;
			width: 46px;
			height: 26px;
			background: #13ce66;
			text-align: center;
			transform: rotate(45deg);

			.el-true-check {
				color: #fff;
				font-size: 12px;
				margin-top: 12px;
				transform: rotate(-45deg);
			}
		}
	}
}
</style>
